import { promise } from '../../../helpers';

const validateOnSaveCertificate = () => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        return promise({ success: true });
    };
};

export default validateOnSaveCertificate;
